<template>
  <div id="lineasProducto">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="LINEAS DE PRODUCTO" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevoProducto"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-linea-producto
                  :openDialog="$store.state.openDialog"
                  :lineaProducto="lineaProducto"
                  ref="dialogLineaProducto"
                  @onLineaProductoAdded="onLineaProductoAdded"
                  @onLineaProductoUpdated="onLineaProductoUpdated"
                ></form-linea-producto>
              </div>

              <v-layout row wrap>
                <v-flex lg6 sm12 xs12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-0">
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="lineasProducto"
                          :search="search"
                          :rows-per-page-items="[
                            10,
                            25,
                            50,
                            { text: 'Todos', value: -1 },
                          ]"
                          class="elevation-1 table-styling"
                          item-key="lineaProductoId"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-icon color="primary">album</v-icon>
                            </td>
                            <td>
                              LI{{ zeroFill(props.item.lineaProductoId, 3) }}
                            </td>
                            <td>{{ props.item.tipoProductoDescripcion }}</td>
                            <td>{{ props.item.descripcion }}</td>
                            <td class="text-xs-right">
                              <v-btn
                                flat
                                icon
                                color="grey"
                                @click="
                                  getLineaProducto(props.item.lineaProductoId)
                                "
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn
                                flat
                                icon
                                color="grey"
                                :loading="$store.state.loadingDelete.show"
                                @click="
                                  deleteLineaProducto(
                                    props.item.lineaProductoId
                                  )
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <v-alert
                            slot="no-results"
                            :value="true"
                            color="error"
                            icon="warning"
                            outline
                            >La búsqueda para "{{ search }}" no encontró
                            registros</v-alert
                          >
                        </v-data-table>
                      </template>
                      <v-divider></v-divider>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formLineaProducto from "./FormLineaProducto";
import catalogoService from "@/services/catalogoServices";
import lineaProductoService from "@/services/lineaProductoService";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    VWidget,
    formLineaProducto,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "ID",
          align: "left",
          value: "lineaProductoId",
          visibility: "hidden-lg-only",
        },
        {
          text: "TIPO PRODUCTO",
          align: "center",
          value: "tipoProductoDescripcion",
        },
        { text: "LÍNEA PRODUCTO", align: "center", value: "descripcion" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      lineasProducto: [],
      lineaProducto: {
        lineaProductoId: 0,
        tipoProductoId: 0,
        descripcion: "",
      },
    };
  },
  mounted() {
    this.getLineasProducto();
  },
  methods: {
    abrirDialogNuevoProducto() {
      this.$store.state.tituloForm = "AGREGAR LINEA PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogLineaProducto.resetForm();
      this.$refs.dialogLineaProducto.openDialog();
    },
    getLineasProducto() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      lineaProductoService
        .getAll()
        .then((result) => {
          self.lineasProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getLineaProducto(lineaProductoId) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      lineaProductoService
        .get(lineaProductoId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR LINEA PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";

          self.$refs.dialogLineaProducto.resetForm();
          self.lineaProducto = result;
          self.$refs.dialogLineaProducto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteLineaProducto(id) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR LINEA PRODUCTO",
          "¿Estás seguro de eliminar la línea de producto seleccionada?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            lineaProductoService
              .delete(id)
              .then((result) => {
                var i = this.lineasProducto.findIndex(
                  (obj) => obj.lineaProductoId == id
                );
                self.lineasProducto.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Línea producto eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onLineaProductoAdded(lineaProducto) {
      this.lineasProducto.push(lineaProducto);
    },
    onLineaProductoUpdated(lineaProducto) {
      var i = this.lineasProducto.findIndex(
        (obj) => obj.lineaProductoId == lineaProducto.lineaProductoId
      );
      this.lineasProducto.splice(i, 1, lineaProducto);
    },
  },
};
</script>

<style>
thead tr th {
  background-color: #00202c;
  color: white !important;
  max-height: 15px;
}
thead tr th i {
  color: white !important;
}
</style>
